import { createAction } from "@reduxjs/toolkit";

export const crudChanged = createAction("app/crudChanged");

const MUTATION_FULFILLED_SUFFIX = "/executeMutation/fulfilled";

export const crudSyncMiddleware = () => {
  let refreshTimer = null;

  const scheduleRefresh = () => {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      refreshTimer = null;
      if (typeof window !== "undefined") {
        // Legacy axios-driven screens still listen for this signal to refresh
        // just their active view without wiping RTK Query caches globally.
        window.dispatchEvent(new CustomEvent("app:crud-changed"));
      }
    }, 120);
  };

  return (next) => (action) => {
    const result = next(action);

    if (crudChanged.match(action)) {
      scheduleRefresh();
      return result;
    }

    if (typeof action?.type === "string" && action.type.endsWith(MUTATION_FULFILLED_SUFFIX)) {
      scheduleRefresh();
    }

    return result;
  };
};
